import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { LogIn, UserPlus, Lock, Mail, User } from 'lucide-react';
import './Login.css';

const Login = () => {
  const { login, register, loading } = useAuth();
  const [isRegisterMode, setIsRegisterMode] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password) return;

    setSubmitting(true);
    try {
      if (isRegisterMode) {
        await register(email.trim(), password, displayName.trim());
      } else {
        await login(email.trim(), password);
      }
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>正在加载...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>📝 猪淇林精选</h1>
          <p>{isRegisterMode ? '创建您的专属食谱账户' : '请登录以访问您的食谱'}</p>
        </div>

        <form onSubmit={handleSubmit} className="login-content">
          {isRegisterMode && (
            <div className="form-group" style={{ textAlign: 'left' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', marginBottom: '6px', color: '#666' }}>
                <User size={14} /> 姓名 / 昵称
              </label>
              <input
                type="text"
                value={displayName}
                onChange={(e) => setDisplayName(e.target.value)}
                placeholder="例如：主厨"
                style={{ width: '100%', padding: '10px 12px', border: '1px solid #e9e9e7', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box' }}
              />
            </div>
          )}

          <div className="form-group" style={{ textAlign: 'left' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', marginBottom: '6px', color: '#666' }}>
              <Mail size={14} /> 邮箱地址 *
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your-email@example.com"
              required
              style={{ width: '100%', padding: '10px 12px', border: '1px solid #e9e9e7', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box' }}
            />
          </div>

          <div className="form-group" style={{ textAlign: 'left' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', marginBottom: '6px', color: '#666' }}>
              <Lock size={14} /> 密码 *
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="至少 6 位密码"
              required
              minLength={6}
              style={{ width: '100%', padding: '10px 12px', border: '1px solid #e9e9e7', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box' }}
            />
          </div>

          <button
            type="submit"
            className="submit-btn"
            disabled={submitting}
            style={{ width: '100%', padding: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', marginTop: '8px', cursor: 'pointer' }}
          >
            {isRegisterMode ? <UserPlus size={16} /> : <LogIn size={16} />}
            {submitting ? '处理中...' : (isRegisterMode ? '立即注册' : '登 录')}
          </button>

          <div className="login-divider">
            <span>或</span>
          </div>

          <button
            type="button"
            className="request-permission-btn"
            onClick={() => setIsRegisterMode(!isRegisterMode)}
          >
            {isRegisterMode ? '已有账号？去登录' : '没有账号？创建新账户'}
          </button>

          <div className="login-info">
            <p>基于 Cloudflare 全栈安全存储</p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
